import { List } from "@material-ui/core";
import React from "react";
import { Venda } from "../../../models/venda";
import { ListItemVendedor } from "../../caixa/ListItemVendedor";
import { DashPanel } from "../DashPanel";

export interface PanelVendaPorVendedorProps {
  vendaPorVendedor: Venda[];
  vendaComparativo?: Venda[];
}

export const PanelVendaPorVendedor = (props: PanelVendaPorVendedorProps) => {
  return <DashPanel title="Venda por Vendedor">
    <List>
      {props.vendaPorVendedor?.map(x => <ListItemVendedor key={x.codigo} vendaPorVendedor={x} comparativo={props.vendaComparativo?.find(c => c.codigo === x.codigo)} />)}
    </List>
  </DashPanel>;
}